import React, { useState, useEffect } from "react";
import Rating from "react-rating-stars-component";
import { Button, Modal, Form } from "react-bootstrap";
import axios from "axios"; // Import Axios




const FeedbackComponent = ({ handleClose }) => {
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [responseRating, setResponseRating] = useState(0);
  const [uiRating, setUIRating] = useState(0);
  const [responseOpinion, setResponseOpinion] = useState("");
  const [uiOpinion, setUIOpinion] = useState("");
  const [responseOpinionError, setResponseOpinionError] = useState("");
  const [uiOpinionError, setUIOpinionError] = useState("");
  const [ipAddress, setIPAddress] = useState('');

  useEffect(() => {
    // Fetch and log IPAddress when FeedbackComponent mounts
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIPAddress(data.ip))
      .catch(error => console.log(error))
  }, []);

  const handleOpenFeedbackModal = () => {
    setFeedbackModalOpen(true);
  };

  const handleCloseFeedbackModal = () => {
    setFeedbackModalOpen(false);
  };


  const handleSubmit = () => {
    let valid = true;

    const timestamp = new Date();
     const formattedTimestamp = timestamp.toISOString();

    if (!responseOpinion) {
      setResponseOpinionError("Please provide your opinion.");
      valid = false;
    } else {
      setResponseOpinionError("");
    }

    if (!uiOpinion) {
      setUIOpinionError("Please provide your opinion.");
      valid = false;
    } else {
      setUIOpinionError("");
    }

    if (valid) {
      // Log the values before handling submission
      console.log("responseRating :",responseRating);
      console.log("Response Opinion:", responseOpinion);
      console.log("UI Rating:", uiRating);
      console.log("UI Opinion:", uiOpinion);
     //reseting the field values after submission
      setResponseOpinion('');
      setResponseRating('');
      setUIOpinion('');
      setUIRating('');

      handleCloseFeedbackModal();
    }

    const formData = {

      responseRating,

      uiRating,

      responseOpinion,

      uiOpinion,

      ipAddress,

      timestamp: formattedTimestamp,

     // interaction, // Include feedback only for negative feedback

    };

    axios

    .post("https://ai.mosip.sandbox.stataware.com/qa/feedback/newqna/_doc", formData)
  
    .then((response) => {
  
      console.log("Response Data:", response.data);
  
      // Close the modal after successfully submitting feedback

      handleClose();
      //handleSubmit();
  
    })
  
    .catch((error) => {
  
      console.error("Error posting feedback:", error);
  
    });

  };

  return (
    <>
      <Button
        className="feedback-button"
        variant="link"
        onClick={handleOpenFeedbackModal}
      >
        <img src="/assets/img/FeedbackIcons.png" alt="Feedback" style={{ maxHeight: '100%', maxWidth: '100%' }}/>
      </Button>

      <Modal show={feedbackModalOpen} onHide={handleCloseFeedbackModal}>
        <Modal.Header closeButton>
          <Modal.Title>Help Us Improve</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {/* Your radio buttons or options for the response */}

          <Form.Group controlId="responseOpinion">
            <Form.Label> How would you rate the overall performance of the bot & why?</Form.Label>
            <Rating
              count={5}
              value={responseRating}
              onChange={(newRating) => setResponseRating(newRating)}
              size={30}
              activeColor="#007bff"
              //   gold color ="#ffd700"
            />
            <Form.Control
              as="textarea"
              rows={3}
              value={responseOpinion}
              onChange={(e) => setResponseOpinion(e.target.value)}
            />

            <Form.Text className="text-danger">
              {responseOpinionError}
            </Form.Text>
          </Form.Group>

          <Form.Group controlId="uiOpinion">
            <Form.Label>Any suggestions for feature inclusions and/or enhancements? </Form.Label>
            <Rating
              count={5}
              value={uiRating}
              onChange={(newRating) => setUIRating(newRating)}
              size={30}
              activeColor="#007bff"
            />
            <Form.Control
              as="textarea"
              rows={3}
              value={uiOpinion}
              onChange={(e) => setUIOpinion(e.target.value)}
            />
            <Form.Text className="text-danger">{uiOpinionError}</Form.Text>
          </Form.Group>
          <Button variant="primary" onClick={handleSubmit} className="submit-button">
            Submit
          </Button>
          <Button
            variant="danger"
            className="cancel-button"
            onClick={handleCloseFeedbackModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FeedbackComponent;
